class NotificationSettings {
  day = 0;

  hour = 0;

  minute = 0;

  timezoneOffset: number = new Date().getTimezoneOffset();
}

export default NotificationSettings;
